import React from 'react';
import MyBread from '../../components/Breadcrumbs';
import { UserInfo } from 'components/UserInfo';
import { CognitoSetMail } from 'components/CognitoSetMail';
import { CognitoSetSMS } from 'components/CognitoSetSMS';
import { CognitoSetPassword } from 'components/CognitoSetPassword';
import { DeleteUser } from 'components/DeleteUser';
import { PageTitle } from 'styles/styles';

export default function User() {
  return (
    <>
      <div>
        <MyBread />
        <div>
          <PageTitle>ユーザー情報</PageTitle>
          <UserInfo />
          <CognitoSetMail />
          <CognitoSetSMS />
          <CognitoSetPassword />
          <DeleteUser />
        </div>
      </div>
    </>
  )
}
